import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'

export const createNonAllocatedSims = async (model: INonAllocatedSimModel[]): Promise<boolean> =>
  axios.post(`/management/nonallocatedsim/addnonallocatedsims`, model).then((res) => res?.data?.result)

type Props = {
  model: INonAllocatedSimModel[]
}

export const useManagementCreateNonAllocatedSims = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['createNonAllocatedSims'],
    mutationFn: ({ model }: Props) => createNonAllocatedSims(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created non allocated sim.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create non allocated sim, please try again.')
      }
    },
    throwOnError: false
  })
